import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { CarregadoresMoneyInput } from "@/components/CarregadoresMoneyInput";

type SaveItemSwitchFieldProps = {
  id: string;
  label: string;
  helperText: string;
  incluir: boolean;
  valor: number;
  onIncluirChange: (incluir: boolean) => void;
  onValorChange: (valor: number) => void;
};

export function SaveItemSwitchField({
  id,
  label,
  helperText,
  incluir,
  valor,
  onIncluirChange,
  onValorChange,
}: SaveItemSwitchFieldProps) {
  return (
    <>
      <div className="flex items-center justify-between gap-4 rounded-lg border p-3">
        <div className="space-y-0.5">
          <Label htmlFor={id} className="text-base">
            {label}
          </Label>
          <p className="text-sm text-muted-foreground">{helperText}</p>
        </div>
        <Switch id={id} checked={incluir} onCheckedChange={onIncluirChange} />
      </div>
      {incluir ? (
        <CarregadoresMoneyInput
          id={`${id}-valor`}
          label={`${label} (R$)`}
          value={Number(valor) || 0}
          onValueChange={onValorChange}
        />
      ) : null}
    </>
  );
}
